import { accessTypes } from "./accessTypes";
import adminPortalRoles from "../app/appUserRoles";

const accessTypeRoles = {
  [accessTypes.applicationSpecific]: [
    adminPortalRoles.ApplicationManager,
    adminPortalRoles.ContentManager,
    adminPortalRoles.Reporter
  ],
  [accessTypes.global]: [adminPortalRoles.Admin],
  [accessTypes.marketSpecific]: [adminPortalRoles.MarketAdmin, adminPortalRoles.FleetManager]
};

export default accessTypeRoles;
